import { asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime, toConsumableArray as _toConsumableArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { LayoutType } from '../types/layouts.esm.js';
import { diffSavedLayouts } from './diff-saved-layouts.esm.js';
import { getCustomLayout } from './get-custom-layout.esm.js';
import { getSelectedLayout } from './get-selected-layout.esm.js';
import { sameArray } from './same-array.esm.js';

var fromDefaultLayout = function fromDefaultLayout(commands) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(liveLayouts, newLayouts) {
      var newLayout, diffed, p1, p2, p3, _diffed, _p, _p2, _p3, p4, oldVersion;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            newLayout = getSelectedLayout(newLayouts);
            _context.t0 = newLayout.type;
            _context.next = _context.t0 === LayoutType.Default ? 4 : _context.t0 === LayoutType.Custom ? 11 : _context.t0 === LayoutType.Predefined ? 19 : _context.t0 === LayoutType.Saved ? 22 : 29;
            break;
          case 4:
            diffed = diffSavedLayouts(liveLayouts, newLayouts);
            p1 = diffed.deletedLayouts.map(function (l) {
              return commands.onDeleteLayout(l);
            });
            p2 = diffed.changedLayouts.map(function (l) {
              return commands.onSaveLayout(l.newVersion);
            });
            p3 = diffed.addedLayouts.map(function (l) {
              return commands.onSaveLayout(l);
            });
            _context.next = 10;
            return Promise.all([].concat(_toConsumableArray(p1), _toConsumableArray(p2), _toConsumableArray(p3)));
          case 10:
            return _context.abrupt("return");
          case 11:
            _diffed = diffSavedLayouts(liveLayouts, newLayouts);
            _p = _diffed.deletedLayouts.map(function (l) {
              return commands.onDeleteLayout(l);
            });
            _p2 = _diffed.changedLayouts.map(function (l) {
              return commands.onSaveLayout(l.newVersion);
            });
            _p3 = _diffed.addedLayouts.map(function (l) {
              return commands.onSaveLayout(l);
            });
            p4 = commands.onSaveLayout(newLayout);
            _context.next = 18;
            return Promise.all([].concat(_toConsumableArray(_p), _toConsumableArray(_p2), _toConsumableArray(_p3), [p4]));
          case 18:
            return _context.abrupt("return");
          case 19:
            _context.next = 21;
            return commands.onSaveLayout(newLayout);
          case 21:
            return _context.abrupt("return");
          case 22:
            oldVersion = liveLayouts.find(function (l) {
              return l.id === newLayout.id;
            });
            if (!oldVersion) {
              _context.next = 26;
              break;
            }
            _context.next = 26;
            return commands.onDeleteLayout(oldVersion);
          case 26:
            _context.next = 28;
            return commands.onSaveLayout(newLayout);
          case 28:
            return _context.abrupt("return");
          case 29:
            throw new Error('Unknown type.');
          case 30:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
var fromCustomLayout = function fromCustomLayout(commands) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(liveLayouts, newLayouts) {
      var newLayout, oldVersion, _oldVersion, diffed, p1, p2, p3, _oldVersion2;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            newLayout = getSelectedLayout(newLayouts);
            _context2.t0 = newLayout.type;
            _context2.next = _context2.t0 === LayoutType.Default ? 4 : _context2.t0 === LayoutType.Custom ? 9 : _context2.t0 === LayoutType.Predefined ? 20 : _context2.t0 === LayoutType.Saved ? 23 : 30;
            break;
          case 4:
            oldVersion = getCustomLayout(liveLayouts);
            if (!oldVersion) {
              _context2.next = 8;
              break;
            }
            _context2.next = 8;
            return commands.onDeleteLayout(oldVersion);
          case 8:
            return _context2.abrupt("return");
          case 9:
            _oldVersion = getCustomLayout(liveLayouts);
            diffed = diffSavedLayouts(liveLayouts, newLayouts);
            p1 = diffed.deletedLayouts.map(function (l) {
              return commands.onDeleteLayout(l);
            });
            p2 = diffed.changedLayouts.map(function (l) {
              return commands.onSaveLayout(l.newVersion);
            });
            p3 = diffed.addedLayouts.map(function (l) {
              return commands.onSaveLayout(l);
            });
            if (sameArray(_oldVersion === null || _oldVersion === void 0 ? void 0 : _oldVersion.fields, newLayout.fields)) {
              _context2.next = 17;
              break;
            }
            _context2.next = 17;
            return commands.onSaveLayout(newLayout);
          case 17:
            _context2.next = 19;
            return Promise.all([].concat(_toConsumableArray(p1), _toConsumableArray(p2), _toConsumableArray(p3)));
          case 19:
            return _context2.abrupt("return");
          case 20:
            _context2.next = 22;
            return commands.onSaveLayout(newLayout);
          case 22:
            return _context2.abrupt("return");
          case 23:
            _oldVersion2 = liveLayouts.find(function (l) {
              return l.id === newLayout.id;
            });
            if (!_oldVersion2) {
              _context2.next = 27;
              break;
            }
            _context2.next = 27;
            return commands.onDeleteLayout(_oldVersion2);
          case 27:
            _context2.next = 29;
            return commands.onSaveLayout(newLayout);
          case 29:
            return _context2.abrupt("return");
          case 30:
            throw new Error('Unknown type.');
          case 31:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var fromPredefinedLayout = function fromPredefinedLayout(commands) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(liveLayouts, newLayouts) {
      var newLayout, oldVersion, diffed, _oldVersion3, p1, p2, p3, _oldVersion4;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            newLayout = getSelectedLayout(newLayouts);
            _context3.t0 = newLayout.type;
            _context3.next = _context3.t0 === LayoutType.Default ? 4 : _context3.t0 === LayoutType.Custom ? 8 : _context3.t0 === LayoutType.Predefined ? 11 : _context3.t0 === LayoutType.Saved ? 22 : 29;
            break;
          case 4:
            oldVersion = getSelectedLayout(liveLayouts);
            _context3.next = 7;
            return commands.onDeleteLayout(oldVersion);
          case 7:
            return _context3.abrupt("return");
          case 8:
            _context3.next = 10;
            return commands.onSaveLayout(newLayout);
          case 10:
            return _context3.abrupt("return");
          case 11:
            diffed = diffSavedLayouts(liveLayouts, newLayouts);
            _oldVersion3 = getSelectedLayout(liveLayouts);
            p1 = diffed.deletedLayouts.map(function (l) {
              return commands.onDeleteLayout(l);
            });
            p2 = diffed.changedLayouts.map(function (l) {
              return commands.onSaveLayout(l.newVersion);
            });
            p3 = diffed.addedLayouts.map(function (l) {
              return commands.onSaveLayout(l);
            });
            if (!(_oldVersion3.id !== newLayout.id)) {
              _context3.next = 19;
              break;
            }
            _context3.next = 19;
            return commands.onSaveLayout(newLayout);
          case 19:
            _context3.next = 21;
            return Promise.all([].concat(_toConsumableArray(p1), _toConsumableArray(p2), _toConsumableArray(p3)));
          case 21:
            return _context3.abrupt("return");
          case 22:
            _oldVersion4 = liveLayouts.find(function (l) {
              return l.id === newLayout.id;
            });
            if (!_oldVersion4) {
              _context3.next = 26;
              break;
            }
            _context3.next = 26;
            return commands.onDeleteLayout(_oldVersion4);
          case 26:
            _context3.next = 28;
            return commands.onSaveLayout(newLayout);
          case 28:
            return _context3.abrupt("return");
          case 29:
            throw new Error('Unknown type.');
          case 30:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var fromSavedLayout = function fromSavedLayout(commands) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(liveLayouts, newLayouts) {
      var newLayout, oldVersion, p, newVersion, oldSavedLayout, newSavedLayout, _p4, _oldSavedLayout, _newSavedLayout, diffed, previousSelectedLayoutId, sameSelectedLayout, p1, p2, p3, newLayoutBeforeUpdate, updatedIds, previousSelectedLayoutUpdated;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            newLayout = getSelectedLayout(newLayouts);
            _context4.t0 = newLayout.type;
            _context4.next = _context4.t0 === LayoutType.Default ? 4 : _context4.t0 === LayoutType.Custom ? 13 : _context4.t0 === LayoutType.Predefined ? 22 : _context4.t0 === LayoutType.Saved ? 30 : 54;
            break;
          case 4:
            oldVersion = getSelectedLayout(liveLayouts);
            p = commands.onDeleteLayout(oldVersion);
            newVersion = newLayouts.find(function (l) {
              return l.id === oldVersion.id;
            });
            if (!newVersion) {
              _context4.next = 10;
              break;
            }
            _context4.next = 10;
            return commands.onSaveLayout(newVersion);
          case 10:
            _context4.next = 12;
            return p;
          case 12:
            return _context4.abrupt("return");
          case 13:
            oldSavedLayout = getSelectedLayout(liveLayouts);
            newSavedLayout = newLayouts.find(function (l) {
              return l.id === oldSavedLayout.id;
            });
            _p4 = commands.onSaveLayout(newLayout);
            if (!newSavedLayout) {
              _context4.next = 19;
              break;
            }
            _context4.next = 19;
            return commands.onSaveLayout(newSavedLayout);
          case 19:
            _context4.next = 21;
            return _p4;
          case 21:
            return _context4.abrupt("return");
          case 22:
            _oldSavedLayout = getSelectedLayout(liveLayouts);
            _newSavedLayout = newLayouts.find(function (l) {
              return l.id === _oldSavedLayout.id;
            });
            _context4.next = 26;
            return commands.onSaveLayout(newLayout);
          case 26:
            if (!_newSavedLayout) {
              _context4.next = 29;
              break;
            }
            _context4.next = 29;
            return commands.onSaveLayout(_newSavedLayout);
          case 29:
            return _context4.abrupt("return");
          case 30:
            diffed = diffSavedLayouts(liveLayouts, newLayouts);
            previousSelectedLayoutId = getSelectedLayout(liveLayouts).id;
            sameSelectedLayout = previousSelectedLayoutId === newLayout.id;
            if (!sameSelectedLayout) {
              _context4.next = 41;
              break;
            }
            p1 = diffed.deletedLayouts.map(function (l) {
              return commands.onDeleteLayout(l);
            });
            p2 = diffed.addedLayouts.map(function (l) {
              return commands.onSaveLayout(l);
            });
            p3 = diffed.changedLayouts.map(function (l) {
              return commands.onSaveLayout(l.newVersion);
            });
            _context4.next = 39;
            return Promise.all([].concat(_toConsumableArray(p1), _toConsumableArray(p2), _toConsumableArray(p3)));
          case 39:
            _context4.next = 53;
            break;
          case 41:
            newLayoutBeforeUpdate = liveLayouts.find(function (l) {
              return l.id === newLayout.id;
            });
            if (newLayoutBeforeUpdate) {
              commands.onDeleteLayout(newLayoutBeforeUpdate);
            }
            commands.onSaveLayout(newLayout);
            updatedIds = [newLayout.id];
            previousSelectedLayoutUpdated = newLayouts.find(function (l) {
              return l.id === previousSelectedLayoutId;
            });
            if (!previousSelectedLayoutUpdated) {
              _context4.next = 50;
              break;
            }
            _context4.next = 49;
            return commands.onSaveLayout(previousSelectedLayoutUpdated);
          case 49:
            updatedIds.push(previousSelectedLayoutUpdated.id);
          case 50:
            diffed.deletedLayouts.forEach(function (l) {
              return commands.onDeleteLayout(l);
            });
            diffed.addedLayouts.filter(function (l) {
              return !updatedIds.includes(l.id);
            }).forEach(function (l) {
              return commands.onSaveLayout(l);
            });
            diffed.changedLayouts.filter(function (l) {
              return !updatedIds.includes(l.newVersion.id);
            }).forEach(function (l) {
              return commands.onSaveLayout(l.newVersion);
            });
          case 53:
            return _context4.abrupt("return");
          case 54:
            throw new Error('Unknown type.');
          case 55:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function (_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var getCommands = function getCommands(commands) {
  return function (liveLayouts, newLayouts) {
    var liveLayout = getSelectedLayout(liveLayouts);
    switch (liveLayout.type) {
      case LayoutType.Default:
        {
          return fromDefaultLayout(commands)(liveLayouts, newLayouts);
        }
      case LayoutType.Custom:
        {
          return fromCustomLayout(commands)(liveLayouts, newLayouts);
        }
      case LayoutType.Predefined:
        {
          return fromPredefinedLayout(commands)(liveLayouts, newLayouts);
        }
      case LayoutType.Saved:
        {
          return fromSavedLayout(commands)(liveLayouts, newLayouts);
        }
      default:
        throw new Error('Unknown type.');
    }
  };
};

export { fromCustomLayout, fromDefaultLayout, fromPredefinedLayout, fromSavedLayout, getCommands };
//# sourceMappingURL=get-commands.esm.js.map
